import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { theme, applyCssVariablesToDom } from 'styles/theme';
import { AuthProvider } from 'contexts/AuthContext';
import { ErpThemeProvider } from 'contexts/ErpThemeContext';
import { ToastProvider } from 'contexts/ToastContext';
import ProtectedRoute from 'components/system/ProtectedRoute';
import HrLayout from 'components/system/HrLayout';
import ErrorBoundary from 'components/system/ErrorBoundary';
import Login from 'pages/Login';
import * as luxon from 'luxon';

if (typeof window !== 'undefined') window.luxon = luxon;

// 기본 토큰을 먼저 주입 (Provider mount 전 FOUC 방지)
applyCssVariablesToDom(theme);

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Wanted Sans';
    src: url('https://cdn.jsdelivr.net/npm/wanted-sans@1.0.3/fonts/webfonts/static/complete/woff2/WantedSans-Regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  html, body, #root {
    height: 100%;
  }

  html {
    font-size: var(--erp-font-size-root, 13px);
  }

  * { margin: 0; padding: 0; box-sizing: border-box; }

  body {
    margin: 0;
    font-family: var(--erp-font-family, ${theme.typography.fontFamily});
    font-size: var(--erp-font-size-md, ${theme.typography.fontSize.md});
    color: var(--erp-color-text, ${theme.colors.text.primary});
    background: var(--erp-color-bg-page, ${theme.colors.background.page});
    -webkit-font-smoothing: antialiased;
  }
`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <AuthProvider>
      <ErpThemeProvider>
        <GlobalStyle />
        <ToastProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <HrLayout />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </ToastProvider>
      </ErpThemeProvider>
    </AuthProvider>
  </ErrorBoundary>
);
